module.exports = __webpack_public_path__ + "static/media/bg.cbbeee2a.jpg";